@import '~style-sheet-helpers/core.less';

.content {
  width: 650px;
}

.form {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  &:first-of-type {
    margin-bottom: 50px;
  }

  .form-item {
    margin: 5px 0;
  }

  .form-check {
    height: auto;
    padding: 5px 0;
  }

  .input-container {
    display: flex;
    flex-direction: column;

    label {
      margin-bottom: 3px;
      font-weight: @bold;
    }
  }

  .submit-button {
    margin-top: 10px;
    width: fit-content;
  }
}
